// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"f8beaf2e","352":"f887824b","910":"af614531","945":"8b434996"}[chunkId] + ".chunk.js";
};